<template>
  <l-cache :get-data="getTeacher" :id="this.$route.query.code || ''" ref="cache">
    <l-layout slot-scope="{data}" :layout="['xs12']">
      <info-card
        :item="data"
        :opts="opts"
        :update-time="data.updateTime"
      >
        <template slot="title-actions">
          <v-btn color="primary" flat @click="(data.phone===null)?phoneDialog=true:transformData(data)" :loading="transformLoading">转化</v-btn>
          <v-btn color="primary" flat @click="$refs.cache.retry()">刷新</v-btn>
        </template>
      </info-card>
      <v-dialog v-model="phoneDialog" max-width="600px" scrollable persistent>
        <v-layout column>
          <v-card>
            <v-card-title style="height: 60px">
              <p>填写手机号码</p>
              <v-spacer></v-spacer>
              <v-btn icon @click="phoneDialog=false">
                <v-icon>
                  {{$vuetify.icons.close}}
                </v-icon>
              </v-btn>
            </v-card-title>
            <v-form ref="phoneForm">
              <v-layout class="pa-3">
                <v-text-field prepend-icon="$vuetify.icons.phone" label="手机号码" v-model="phone" :rule="$rules.requiredS()"></v-text-field>
              </v-layout>
            </v-form>
            <v-layout justify-center>
              <v-btn class="primary" @click="transformData(data)" :loading="transformLoading">转化</v-btn>
            </v-layout>
          </v-card>
        </v-layout>
      </v-dialog>
    </l-layout>
  </l-cache>
</template>

<script>
import InfoCard from '../../../../../components/infoCard'

export default {
  name: 'TeacherDetails',
  components: {InfoCard},
  data () {
    return {
      transformLoading: false,
      phoneDialog: false,
      phone: '',
      opts: [
        {
          key: 'name',
          label: '姓名',
          layout: ['xs12', 'sm4'],
          icon: '$vuetify.icons.person',
        },
        {
          key: 'code',
          label: '工号',
          layout: ['xs12', 'sm4'],
          icon: '$vuetify.icons.loginId',
        },
        {
          key: 'phone',
          label: '电话',
          layout: ['xs12', 'sm4'],
          icon: '$vuetify.icons.phone',
        },
        {
          key: 'statusName',
          label: '状态',
          layout: ['xs12', 'sm4'],
          icon: 'mdi-pin',
        },
        {
          key: 'statusCode',
          label: '状态代码',
          layout: ['xs12', 'sm4'],
          icon: 'mdi-pin',
        },
        {
          key: 'orgCode',
          label: '单位代码',
          layout: ['xs12', 'sm4'],
          icon: '$vuetify.icons.levelCode',
        },
        {
          key: 'orgName',
          label: '单位名称',
          layout: ['xs12'],
          icon: '$vuetify.icons.group',
        },
      ]
    }
  },
  methods: {
    async getTeacher (key) {
      let {items} = await this.$store.dispatch('mva/getTeachers', {
        pagination: {},
        filterItems: [{value:key}],
        precious: true
      })
      if (!items.length) {
        throw new Error('未找到该教师')
      }
      return items[0]
    },
    async transformData (data) {
      if (!this.$refs.phoneForm.validate()) {
        this.$L.alert('error', {message: '表单数据不合法'})
        return
      }
      if (data.phone !== null) {
        this.phone = data.phone
      }
      console.log(data)
      let params = {
        'infos': [
          {
            'code': data.code,
            'name': data.name,
            'phone': this.phone
          }
        ]
      }
      this.transformLoading = true
      try {
        let res = await this.$store.dispatch('userAdmin/transformData', params)
        if (res.data.status + '' === '1') {
          this.$L.alert('success', {message: '数据转化成功'})
        }
        else {
          this.$L.alert('error', {message: '转化失败，原因:' + res.data.msg})
        }
      }
      catch (e) {
        console.log(e)
      }
      finally {
        this.transformLoading = false
      }
    }
  }
}
</script>

<style scoped>

</style>
